import { debounce, set } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'

export default [
  debounce(10),
  {
    continue: [set(state`media.details.scale`, props`value`)],
    discard: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onScaleDetailedImage.js